// extracted by mini-css-extract-plugin
module.exports = {"ImageGalleryUI":"ImageGalleryUI_ImageGalleryUI__XjQaP","cssAnimation":"ImageGalleryUI_cssAnimation__2uFKg"};